const isHttpProtocol = (url) => {
    return url.protocol === 'http:' || url.protocol === 'https:';
}

export const appendExternalBearerToken = (rawUrl, options = {}) => {
    if (!rawUrl || typeof rawUrl !== 'string') {
        return rawUrl;
    }

    const token = options.token || sessionStorage.getItem('token');
    if (!token) {
        return rawUrl;
    }

    try {
        const parsedUrl = new URL(rawUrl, window.location.origin);
        const isExternal = parsedUrl.origin !== window.location.origin;
        if (!isExternal || !isHttpProtocol(parsedUrl)) {
            return rawUrl;
        }

        parsedUrl.searchParams.set('access_token', token);
        parsedUrl.searchParams.set('token_type', 'Bearer');
        parsedUrl.searchParams.set('source', 'mtska_admin');

        return parsedUrl.toString();
    } catch (error) {
        return rawUrl;
    }
}
